import { makeStyles, Tab, TabList } from '@fluentui/react-components';
import type { SelectTabData, SelectTabEvent } from '@fluentui/react-components';
import { TResolutionTab } from '../../types';

const useStyles = makeStyles({
  root: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    rowGap: '.5rem',
  },
});

type TProps = {
  resolutionTabs: TResolutionTab[];
  selectedResolutionTab: string;
  setSelectedResolutionTab: (tab: string) => void;
};

const ResolutionTabs = ({ resolutionTabs, selectedResolutionTab, setSelectedResolutionTab }: TProps) => {
  const styles = useStyles();

  const handleOnResolutionTabSelect = (_: SelectTabEvent, data: SelectTabData) => {
    setSelectedResolutionTab(data.value as string);
  };

  return (
    <div className={styles.root}>
      <TabList size="small" selectedValue={selectedResolutionTab} onTabSelect={handleOnResolutionTabSelect}>
        {resolutionTabs.map((tab) => (
          <Tab key={tab.value} value={tab.value}>
            {tab.text}
          </Tab>
        ))}
      </TabList>
    </div>
  );
};

export default ResolutionTabs;
